import { render, staticRenderFns } from "./CategoryMenuListPage.vue?vue&type=template&id=951a9d00&"
import script from "./CategoryMenuListPage.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports